import { useContext, useRef, useState } from "react";
import tools from "../../../../helpers/tools";
import MenuFlottant from "../../MenuFlottant/MenuFlottant";
import { TodoContext } from "../context/TodoContext";
import { nomDeTache } from "../resumeTaches";
import useTodoList from "../useTodoList";
import { ChangerTache, NoteTache } from "./EditeursTache";

const FORMAT_DATE = "dd/MM 'à' HH:mm";

// Une ligne de tâche : poignée (react-beautiful-dnd), case, nom, note, qui et
// quand ; à droite la note et le menu « plus d'actions » (changer de tâche,
// supprimer). La note et le changement de tâche s'éditent en place.
const TodoItem = ({ poignee }) => {
  const { todo, actions } = useContext(TodoContext);
  const { availableTasks } = useTodoList();
  const [edition, setEdition] = useState(null); // "note" | "changer" | null
  const [menuOuvert, setMenuOuvert] = useState(false);
  const refNote = useRef(null);
  const refMenu = useRef(null);
  const nom = nomDeTache(availableTasks, todo);
  const idCase = `tl-case-${todo.id}`;

  const fermerEdition = (refFocus) => {
    setEdition(null);
    if (refFocus && refFocus.current) refFocus.current.focus();
  };
  const cocher = (evenement) => actions.updateTodo({ ...todo, isDone: evenement.target.checked });
  const enregistrerNote = (text) => {
    if (text !== (todo.text || "")) actions.updateTodo({ ...todo, text });
    fermerEdition(refNote);
  };
  const changerTache = (taskId) => {
    actions.updateTodo({ ...todo, taskId });
    fermerEdition(refMenu);
  };
  const supprimer = () => {
    setMenuOuvert(false);
    actions.deleteTodo(todo.id);
  };

  return (
    <>
      <button
        type="button"
        className="tl-poignee"
        {...poignee}
        aria-label={`Réordonner « ${nom} »`}
        title="Glisser pour réordonner"
      >
        <i className="fa fa-grip-vertical" aria-hidden="true" />
      </button>
      <input
        type="checkbox"
        className="tl-case"
        id={idCase}
        checked={Boolean(todo.isDone)}
        onChange={cocher}
        aria-label={`${todo.isDone ? "Tâche faite" : "Tâche à faire"} : ${nom}`}
      />
      <div className="tl-corps">
        <label className="tl-nom" htmlFor={idCase}>
          {nom}
        </label>
        {todo.text && edition !== "note" && (
          <div className="tl-note">
            <i className="fa fa-comment-dots" aria-hidden="true" />
            <span>{todo.text}</span>
          </div>
        )}
        <div className="tl-meta">
          Créée par <b>{todo.createdBy || "Perceval"}</b> le {tools.formatDate(todo.createdAt, FORMAT_DATE)}
          {todo.updatedBy && (
            <>
              {" · "}Modifiée par <b>{todo.updatedBy}</b> le {tools.formatDate(todo.updatedAt, FORMAT_DATE)}
            </>
          )}
        </div>
        {edition === "note" && <NoteTache todo={todo} onEnregistrer={enregistrerNote} onAnnuler={() => fermerEdition(refNote)} />}
        {edition === "changer" && (
          <ChangerTache
            todo={todo}
            taches={availableTasks || []}
            onChanger={changerTache}
            onAnnuler={() => fermerEdition(refMenu)}
          />
        )}
      </div>
      <div className="tl-actions">
        <button
          type="button"
          className={`tl-bouton-icone${todo.text ? " tl-bouton-icone--note" : ""}`}
          ref={refNote}
          aria-label={todo.text ? "Modifier la note" : "Ajouter une note"}
          title={todo.text ? "Modifier la note" : "Ajouter une note"}
          aria-expanded={edition === "note"}
          onClick={() => setEdition(edition === "note" ? null : "note")}
        >
          <i className={`fa ${todo.text ? "fa-comment-dots" : "fa-comment"}`} aria-hidden="true" />
        </button>
        <div className="tl-ancre">
          <button
            type="button"
            className="tl-bouton-icone"
            ref={refMenu}
            aria-label="Plus d'actions"
            title="Plus d'actions"
            aria-haspopup="menu"
            aria-expanded={menuOuvert}
            onClick={() => setMenuOuvert(!menuOuvert)}
          >
            <i className="fa fa-ellipsis-h" aria-hidden="true" />
          </button>
          <MenuFlottant ouvert={menuOuvert} onFermer={() => setMenuOuvert(false)} refBouton={refMenu} titre="Tâche" largeur={220}>
            <button
              type="button"
              role="menuitem"
              className="la-menu__item"
              onClick={() => {
                setMenuOuvert(false);
                setEdition("changer");
              }}
            >
              <i className="fa fa-exchange-alt la-menu__icone" aria-hidden="true" />
              Changer de tâche
            </button>
            <div className="la-menu__sep" />
            <button type="button" role="menuitem" className="la-menu__item la-menu__item--danger" onClick={supprimer}>
              <i className="fa fa-trash-alt la-menu__icone" aria-hidden="true" />
              Supprimer
            </button>
          </MenuFlottant>
        </div>
      </div>
    </>
  );
};

export default TodoItem;
